export const PASSWORD_REQUIRED = 'Password is required!';
export const PASSWORD_VALIDATION =
  'Password must contain number, uppercase, lowercase, one special character. Password must be at least 8 characters long!';
